/**
 * Cookie consent gate for tenants with view_config.template.consent_required = 'yes'.
 *
 * Three buckets are supported: strictly necessary (always on, not represented in
 * state), `functional` (Google Maps, Webfont Loader; defaults on for new visitors),
 * and `analytics` (Google Analytics, Hotjar, Freespee, tenant-injected snippets;
 * defaults off until the visitor accepts).
 *
 * The server renders an early bootstrap in layouts/consent-bootstrap.blade.php
 * that defines window.SP_CONSENT and a window.spConsent(bucket, fn) helper which
 * fires the callback immediately if the bucket is allowed or queues it otherwise.
 *
 * Any decision (Accept all, Reject all, Save preferences) writes the cookie and
 * reloads the page so SP_CONSENT is re-rendered server-side and scripts wire up
 * cleanly under the new state.
 */

(function () {
    'use strict';

    var SPC = window.SP_CONSENT || { required: false };
    if (!SPC.required) {
        return;
    }

    var COOKIE_NAME = 'sp_consent';
    var COOKIE_DAYS = 180;
    var BUCKETS = ['functional', 'analytics'];

    function writeCookie(state) {
        var date = new Date();
        date.setTime(date.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
        var secure = document.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(state)) +
            '; expires=' + date.toUTCString() + '; path=/; SameSite=Lax' + secure;
    }

    function readCookie() {
        var match = document.cookie.match(/(?:^|;\s*)sp_consent=([^;]+)/);
        if (!match) return null;
        try {
            return JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            return null;
        }
    }

    function clearAnalyticsCookies() {
        // Best-effort: current host + naive parent. Doesn't handle multi-label
        // TLDs like `.co.uk` (parent resolves to `co.uk` which the browser
        // rejects). Acceptable for now — left as follow-up if a UK tenant
        // reports lingering `_ga` cookies after withdrawing consent.
        var host = document.location.hostname;
        var parent = host.split('.').slice(-2).join('.');
        var domains = ['', host, '.' + host, parent, '.' + parent];
        var patterns = [/^_ga$/, /^_gid$/, /^_ga_/, /^_gat/, /^_hj/, /^_gcl_/, /^NID$/, /^1P_JAR$/];
        document.cookie.split(';').forEach(function (raw) {
            var name = raw.split('=')[0].trim();
            if (!patterns.some(function (re) { return re.test(name); })) return;
            domains.forEach(function (d) {
                document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' +
                    (d ? '; domain=' + d : '');
            });
        });
    }

    function setCustomiseExpanded(expanded) {
        var trigger = document.querySelector('[data-sp-consent="customise"]');
        if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function hideBanner() {
        var el = document.getElementById('sp-consent-banner');
        if (el) el.style.display = 'none';
        setCustomiseExpanded(false);
        if (document.body) document.body.classList.remove('sp-banner-visible');
    }

    function showBanner() {
        var el = document.getElementById('sp-consent-banner');
        if (el) el.style.display = '';
        var panel = document.getElementById('sp-consent-customise');
        if (panel) panel.style.display = 'none';
        setCustomiseExpanded(false);
        syncToggles();
        if (document.body) document.body.classList.add('sp-banner-visible');
    }

    function showCustomise() {
        var panel = document.getElementById('sp-consent-customise');
        if (panel) panel.style.display = '';
        setCustomiseExpanded(true);
        syncToggles();
        // Move focus into the panel so keyboard users land on the first toggle.
        var firstToggle = document.getElementById('sp-consent-toggle-' + BUCKETS[0]);
        if (firstToggle && typeof firstToggle.focus === 'function') firstToggle.focus();
    }

    function syncToggles() {
        BUCKETS.forEach(function (bucket) {
            var el = document.getElementById('sp-consent-toggle-' + bucket);
            if (el) el.checked = !!SPC[bucket];
        });
    }

    function commit(nextState) {
        BUCKETS.forEach(function (bucket) {
            SPC[bucket] = !!nextState[bucket];
        });
        var record = { functional: !!nextState.functional, analytics: !!nextState.analytics, ts: Date.now() };
        writeCookie(record);
        if (!record.analytics) clearAnalyticsCookies();
        window.location.reload();
    }

    window.SPConsent = {
        acceptAll: function () { commit({ functional: true, analytics: true }); },
        rejectAll: function () { commit({ functional: false, analytics: false }); },
        savePreferences: function () {
            var state = {};
            BUCKETS.forEach(function (bucket) {
                var el = document.getElementById('sp-consent-toggle-' + bucket);
                state[bucket] = el ? !!el.checked : !!SPC[bucket];
            });
            commit(state);
        },
        openSettings: function () { showBanner(); showCustomise(); },
        has: function (bucket) { return !SPC.required || !!SPC[bucket]; }
    };

    document.addEventListener('DOMContentLoaded', function () {
        var banner = document.getElementById('sp-consent-banner');
        if (!banner) return;

        var bind = function (selector, handler) {
            banner.querySelectorAll(selector).forEach(function (el) {
                el.addEventListener('click', function (e) { e.preventDefault(); handler(); });
            });
        };
        bind('[data-sp-consent="accept"]', window.SPConsent.acceptAll);
        bind('[data-sp-consent="reject"]', window.SPConsent.rejectAll);
        bind('[data-sp-consent="save"]', window.SPConsent.savePreferences);
        bind('[data-sp-consent="customise"]', showCustomise);

        document.querySelectorAll('[data-sp-consent="open"]').forEach(function (btn) {
            btn.addEventListener('click', function (e) { e.preventDefault(); window.SPConsent.openSettings(); });
        });

        syncToggles();
        if (readCookie() === null) showBanner();
    });
})();



// WEBPACK FOOTER //
// ./resources/assets/js/consent.js